jQuery($ => {
	// region VARIABLES

	// Header
	const header = {
		this: $('#header'),
		get button(){return this.this.find('.header_button').first()}
	};

	// endregion VARIABLES

	// region INITIALIZATION

	Init();

	function Init()
	{
		// Setup header
		SetupHeader();
	}

	function SetupHeader()
	{
		// Setup header listeners
		header.button.on({
			click: function(event){
				$('html, body').stop().animate({scrollTop: $('#main').first().offset().top - $('#navbar').outerHeight(true)}, glob.params.scrollSpeed);
			}
		});

		// Setup header parallax
		header.this.find('.jarallax').children('#wp-custom-header').jarallax({
			type: 'scroll',
			speed: 0.5,
			imgSrc: null,
			imgElement: 'img',
			imgSize: 'cover',
			imgPosition: '50% 50%',
			imgRepeat: 'no-repeat'
		});
	}

	// endregion INITIALIZATION
});